import { useContext } from "react";
import { Link, useLocation } from "react-router";
import { CourseworkRefusal } from "@/components/assignments/CourseworkRefusal";
import { a3Copy } from "@/components/assignments/a3-copy";
import { WorkBoxes } from "@/components/assignments/coursework/WorkBoxHost";
import { BentoVisit } from "@/components/ui/box-visit-context";
import { useMaterialModels, type MaterialModelOptions } from "./use-material-models";
import { MaterialRegister } from "./MaterialRegister";

export function MaterialBoxes(props: MaterialModelOptions) {
  const host = useContext(BentoVisit);
  return host ? <MaterialRegister {...props} /> : <InlineMaterials {...props} />;
}

/** Compatibility for existing embedded/non-visit consumers, same controller. */
function InlineMaterials(props: MaterialModelOptions) {
  const models = useMaterialModels(props), location = useLocation();
  if (models.refusal) return <CourseworkRefusal id="materials-refusal"><p>{models.refusal === "course" ? a3Copy.thisCourseSMaterialsAreUnavailable : a3Copy.thisMaterialIsUnavailable}</p><Link data-act="exit" to={location.pathname}>{models.refusal === "course" ? a3Copy.backToCourse : a3Copy.backToMaterials}</Link></CourseworkRefusal>;
  return <WorkBoxes id={`materials-${props.courseId}`} zone={props.timezone ?? undefined} boxes={models.boxes} journey="materials" />;
}
